import MatchedMap from 'utilities/src/matchedMap';

import { InputStateEnum } from '../../../utils/state';
import { InputThemeEnum, type InputThemeProps } from '../../../utils/themes';

/**
 * MessageHelper Common Classes
 */

const messageHelperTextClasses = 'font-medium paragraph-xs';

/**
 * MessageHelper Theme State Classes
 */

const messageHelperTextDarkStateClassesMap = new MatchedMap([
  [InputStateEnum.Default, 'text-neutrals-50'],
  [InputStateEnum.Disabled, 'text-neutrals-50'],
  [InputStateEnum.Error, 'text-neutrals-50'],
  [InputStateEnum.Success, 'text-success-300'],
]);

const messageHelperTextLightStateClassesMap = new MatchedMap([
  [InputStateEnum.Default, 'text-neutrals-800'],
  [InputStateEnum.Disabled, 'text-neutrals-800'],
  [InputStateEnum.Error, 'text-neutrals-800'],
  [InputStateEnum.Success, 'text-success-600'],
]);

const messageHelperTextStateClassesMap = new MatchedMap([
  [InputThemeEnum.Dark, messageHelperTextDarkStateClassesMap],
  [InputThemeEnum.Light, messageHelperTextLightStateClassesMap],
]);

/**
 * Blog Theme
 */

const inputMessageHelperBlogTheme = ({
  inputTheme,
  inputState,
}: Pick<InputThemeProps, 'inputTheme' | 'inputState'>) => ({
  messageHelperTextThemeClasses: messageHelperTextClasses,
  messageHelperTextStateThemeClasses: messageHelperTextStateClassesMap
    .get(InputThemeEnum[inputTheme])
    .get(InputStateEnum[inputState]),
});

export default inputMessageHelperBlogTheme;
